import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n    top: 20px;\n    right: 20px;\n  "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    background-image: url(", ");\n    width: 24px;\n    height: 24px;\n    position: absolute;\n    top: 40px;\n    right: 40px;\n    z-index: 1;\n  "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  ", "\n\n  ", "\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n      display: block;\n    "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  &.button {\n    font-size: 13px;\n    line-height: 13px;\n    min-width: 230px;\n    margin-bottom: 32px;\n    display: none;\n    ", "\n  }\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n    font-size: 18px;\n    margin-bottom: 32px;\n  "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 22px;\n  line-height: normal;\n  color: #bdbdbd;\n  ", "\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 10px;\n    font-size: 14px;\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 20px;\n    font-size: 18px;\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 10px;\n    font-size: 18px;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 22px;\n  margin-bottom: 20px;\n  line-height: 1.2em;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  min-height: 200px;\n  align-items: center;\n  justify-content: flex-start;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 36px;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 50px;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 36px;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 50px;\n  width: 100%;\n  ", " \n  ", "\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    width: 18px;\n    height: 18px;\n    font-size: 12px;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  font-size: 14px;\n  ", "\n  color: #ffffff;\n  border-radius: 50%;\n  background-color: #000000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 10px;\n  span {\n    transform: translateX(0.1em);\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 34px;\n    margin-top: 44px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    border: none;\n    padding-bottom: 0;\n    margin-bottom: 72px;\n    margin-top: 100px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: 13px;\n    line-height: 13px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 18px;\n  ", "\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  padding-bottom: 18px;\n  width: 100%;\n  margin-bottom: 36px;\n  border-bottom: 1px solid #e9e9e9;\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 auto;\n    padding: 0 33px;\n    overflow-y: auto;\n    ::before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 40px;\n      right: 0;\n      background: linear-gradient(\n        to bottom,\n        rgba(255, 255, 255, 1) 0%,\n        rgba(255, 255, 255, 0) 100%\n      );\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: center;\n  max-width: calc(425px + 33px * 2);\n  margin: 0 auto;\n  position: relative;\n  margin: 0 -42px;\n  padding: 0 42px;\n  ", "\n\n  scrollbar-width: none;\n  ::-webkit-scrollbar {\n    width: 0px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import crossIcon from "images/close.svg";
import { Button } from "../../../../components";
export var Wrapper = styled.div(_templateObject(), media.xLargeScreen(_templateObject2()));
export var Header = styled.div(_templateObject3(), media.xxLargeScreen(_templateObject4()), media.xLargeScreen(_templateObject5()), media.smallScreen(_templateObject6()));
export var ActiveFilters = styled.div(_templateObject7(), media.xxLargeScreen(_templateObject8()));
export var FilterGroup = styled.div(_templateObject9(), media.xxLargeScreen(_templateObject10()), media.xLargeScreen(_templateObject11()), media.smallScreen(_templateObject12()));
export var ButtonFilterGroup = styled.div(_templateObject13());
export var FilterTitle = styled.div(_templateObject14(), function (props) {
  return props.theme.colors.baseFont;
}, media.xxLargeScreen(_templateObject15()), media.xLargeScreen(_templateObject16()), media.smallScreen(_templateObject17()));
export var ClearButton = styled.button(_templateObject18(), media.xLargeScreen(_templateObject19()));
export var DoneButton = styled(Button)(_templateObject20(), media.xLargeScreen(_templateObject21()));
export var CloseButton = styled.button(_templateObject22(), media.xLargeScreen(_templateObject23(), crossIcon), media.smallScreen(_templateObject24()));